import { useState, useEffect } from 'react';

/**
 * Debounces a value. Useful for search inputs to avoid excessive API calls.
 * @param {*} value - The value to debounce
 * @param {number} delay - Delay in ms
 * @returns {*} - The debounced value
 */
export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
